import qs from "query-string";

/**
 * Verify whether to allow draft Contentful API entries to be returned.
 * Allow draft entries if URL contains query string `?preview=1` and the
 * previewToken is available.
 * @returns {boolean}
 */
const isContentfulPreview = (queryStringOrObj, previewToken) => {
  const isQueryString = typeof queryStringOrObj === "string";
  const queryObj = isQueryString
    ? qs.parse(queryStringOrObj)
    : queryStringOrObj;
  const hasPreviewParam = queryObj?.preview === "1";
  const hasPreviewToken = previewToken != null;

  return hasPreviewParam && hasPreviewToken;
};

export default isContentfulPreview;
